import {
  Component,
  AfterViewChecked,
  ChangeDetectorRef,
  Inject,
} from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { ToastService } from '../../services/toast/toast.service';
import {
  MsalService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import { AuthenticationResult, RedirectRequest } from '@azure/msal-browser';
import { LoadingService } from '../loading/loading.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements AfterViewChecked {
  private readonly _destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalAuthService: MsalService,
    private changeDetectorRef: ChangeDetectorRef,
    private authService: AuthService,
    private toastService: ToastService,
    private loadingService: LoadingService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadingService.showLoading();
    this.msalAuthService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult) => {
        if (!result) {
          return this.login();
        }
        this.handleLoginSuccess(result);
      },
      error: (error) => console.log(error),
    });
  }

  private async handleLoginSuccess(result: any) {
    await this.authService.onLogin(result.accessToken || '');
    this.msalAuthService.instance.setActiveAccount(result.account);
    this.toastService.showSuccess(
      'Login realizado com sucesso.',
      'toast-right'
    );
     this.router.navigate(['/home']);
  }

  login() {
    const request: RedirectRequest = this.msalGuardConfig.authRequest
      ? { ...this.msalGuardConfig.authRequest as RedirectRequest, prompt: 'login' }
      : { scopes: [], prompt: 'login' };
    this.msalAuthService.loginRedirect(request);
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }
}
